import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { IPixel } from 'interfaces/IProductData';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import { TRACKER_URL } from 'settings';

export enum enPixelPath {
  BANKSLIP = 'boleto',
  CHECKOUT = 'checkout',
  THANKYOU = 'thankyou',
  THANKYOU_BANKSLIP = 'obg_boleto',
}

export class PixelService {

  private pixel$ = new ReplaySubject<IPixel>(1);
  private pixelPath$ = new ReplaySubject<enPixelPath>(1);

  private baseUrl = TRACKER_URL;

  track(path: enPixelPath): void {
    this.pixelPath$.next(path);
  }

  setPixel(pixel: IPixel) {
    this.pixel$.next(pixel);
  }

  getPixelPathStream(): Observable<enPixelPath> {
    return this.pixelPath$.asObservable();
  }

  getPixelStream(): Observable<IPixel> {
    return this.pixel$.asObservable();
  }

  getPixel(): Observable<string> {
    return Observable.combineLatest(this.getPixelStream(), this.getPixelPathStream())
      .filter(([pixel, path]) => !!(pixel && pixel.campaign && pixel.userId))
      .map(([pixel, path]) => {
        const campaign = pixel.campaign.replace('g/', '--');
        return `${this.baseUrl}/${path}/${pixel.userId}/${campaign}`;
      })
      .distinctUntilChanged();
  }

  getParameterPixel(): Observable<string> {
    return parameterService
      .get(enParameters.a)
      .filter((param) => !!param)
      .switchMap(() => this.pixel$.asObservable())
      .filter((pixel) => !!pixel.contentId)
      .map((pixel) => {
        return `https://my.eduzz.com/lp/edz/${pixel.contentId}/${pixel.userId}`;
      });
  }
}

// tslint:disable-next-line:variable-name
export const PixelServiceFactory = () => new PixelService();

export const pixelService = PixelServiceFactory();


// WEBPACK FOOTER //
// ./src/services/PixelService.ts